import {EntityField} from "../../../core/genericdocuments/EntityField";
import {EntityFieldDataType} from "../../../core/genericdocuments/EntityFieldDataType";
import {EntityFieldsDescriptor} from "../../../core/genericdocuments/EntityFieldsDescriptor";
import {EmployeeContractDocument} from "./EmployeeContractDocument";

export const employeeContractDocumentFields: IntercateKeysMap<EmployeeContractDocument, EntityField<EmployeeContractDocument>> = {
	id: {
		name: "id", dataType: EntityFieldDataType._string, label: "Contract number"
	},
	dateFrom: {
		name: "dateFrom", dataType: EntityFieldDataType._date, label: "Valid from",
		validator: { required: true },
		sortable: true,
		filterable: true
	},
	dateTo: {
		name: "dateTo", dataType: EntityFieldDataType._date, label: "Valid to",
		sortable: true,
		validator: { required: false }
	},
	comment: {
		name: "comment", dataType: EntityFieldDataType._string, label: "Comment"
	},
};

const employeeContractDocumentFieldsArray: Array<EntityField<EmployeeContractDocument>> = [
	employeeContractDocumentFields.id,
	employeeContractDocumentFields.dateFrom,
	employeeContractDocumentFields.dateTo,
	employeeContractDocumentFields.comment
];

export const employeeContractDocumentFieldsDescriptor: EntityFieldsDescriptor<EmployeeContractDocument> = {
	listFields: employeeContractDocumentFieldsArray,
	createFormFields: employeeContractDocumentFieldsArray,
	updateFormFields: employeeContractDocumentFieldsArray
}
